export enum AppRoutes {
  BASE_ROUTE = "/",
  INFOS_VALIDATIONS = "/infos-validations",
}
